/*!

=========================================================
* Argon Design System React - v1.1.2
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col,
} from "reactstrap";
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import MainFooter from "components/Footers/MainFooter.js";
import { AddLessonToDB } from "../../services/AdminServices";

const AddLesson = () => {
  const [state, setState] = useState({
    documentID: "",
    lessonModule: "",
    lessonTitle: "",
    courseID: "",
    lessonType: "",
    error: null,
    message: null,
  });

  const mainRef = useRef(null);

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainRef.current.scrollTop = 0;
  }, []);

  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const { documentID, lessonModule, lessonTitle, courseID, lessonType } = state;

    try {
      await AddLessonToDB(documentID, lessonModule, lessonTitle, courseID, lessonType);
      setState({
        ...state,
        message: "User Added Lesson successfully!",
        error: null,
      });
    } catch (error) {
      setState({ ...state, error: error.message, message: null });
    }
  };

  return (
    <>
      <DemoNavbar />
      <main ref={mainRef}>
        <section className="bordersection section-shaped section-lg">
          <div className="shape shape-style-1 bg-gradient-default">
            <span />
            <span />
            <span />
            <span />
            <span />
            <span />
            <span />
            <span />
          </div>
          <Container className="pt-lg-7">
            <Row className="justify-content-center">
              {/* Progressive sizing: full-width on phones, narrower on each
                  larger breakpoint. Avoids a 100%-wide form on tablets that
                  would have stretched inputs awkwardly across the screen. */}
              <Col xs="12" md="10" lg="6" xl="5">
                <Card className="bg-secondary shadow border-0">
                  <CardHeader className="bg-white pb-5">
                    <div className="text-muted text-center mb-3">
                      <small>Add Lesson To DB</small>
                    </div>
                  </CardHeader>
                  <CardBody className="px-lg-5 py-lg-5">
                    <Form onSubmit={handleSubmit} role="form">

                      <FormGroup>
                        <label className="required">Document ID</label>
                        <InputGroup className="input-group-alternative mb-3">
                          <Input
                            placeholder="Enter Document ID"
                            name="documentID"
                            type="text"
                            onChange={handleChange}
                          />
                        </InputGroup>
                      </FormGroup>
                      <FormGroup>
                        <label className="required">Lesson Module</label>
                        <InputGroup className="input-group-alternative mb-3">
                          <Input
                            placeholder="Enter Lesson Module"
                            name="lessonModule"
                            type="text"
                            onChange={handleChange}
                          />
                        </InputGroup>
                      </FormGroup>
                      <FormGroup>
                        <label className="required">Course</label>
                        <InputGroup className="input-group-alternative mb-3">
                          <Input
                            type="select"
                            name="courseID"
                            onChange={handleChange}
                          >
                            <option value="" disabled selected>
                              Select a Course
                            </option>
                            <option value="JA01">JAVA (JA01)</option>
                            <option value="JA02">JAVA (JA02)</option>
                            <option value="JA03">Course 3</option>
                            <option value="JS01">JavaScript (JS01)</option>
                            <option value="CC01">CC01</option>
                            <option value="CD01">Claude AI Developer (CD01)</option>
                            {/* Add more options as needed */}
                          </Input>
                        </InputGroup>
                      </FormGroup>
                      <FormGroup>
                        <label className="required">Lesson Type</label>
                        <InputGroup className="input-group-alternative mb-3">
                          <Input
                            type="select"
                            name="lessonType"
                            onChange={handleChange}
                          >
                            <option value="" disabled selected>
                              Select a Type
                            </option>
                            <option value="lecture">Lecture</option>
                            <option value="project">Project</option>
                            <option value="quiz">Quiz</option>
                            {/* Add more options as needed */}
                          </Input>
                        </InputGroup>
                      </FormGroup>
                      <FormGroup>
                        <label >Lesson Title</label>
                        <InputGroup className="input-group-alternative">
                          <Input
                            placeholder="Enter Lesson Name"
                            name="lessonTitle"
                            type="text"
                            onChange={handleChange}
                          />
                        </InputGroup>
                      </FormGroup>

                      <div className="text-center">
                        <Button className="mt-4" color="primary" type="submit">
                          Add Lesson
                        </Button>
                      </div>
                    </Form>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </section>
      </main>
      <MainFooter />
    </>
  );
};

export default AddLesson;
